import { Box, useMediaQuery, useTheme } from '@mui/material';
import Grid from '@mui/material/Grid2';
import React, { useState } from 'react';
import { ILayout } from '../interfaces/shared/ILayout';
import Header from './Header';
import Sidebar from './Sidebar';

interface IProps {
  children: React.ReactNode;
  routes: ILayout[] | undefined;
}

const Layout = ({ children, routes }: IProps) => {
  const [isCollapsed, setIsCollapsed] = useState(
    localStorage.getItem('menuCollapsed') === 'true',
  );
  const filteredRoutes = routes?.filter((route) => route?.showInSidebar);

  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down('md')); // Hides sidebar on md and below
  return (
    <Box sx={{ padding: { xs: 0, lg: '20px' } }}>
      <Grid container spacing={2}>
        {!isMobileOrTablet && (
          <Grid
            size={'auto'}
            sx={{
              height: '85vh',
              position: 'sticky',
              top: '20px',
              transition: 'all .3 ease-in-out',
            }}
            id={'sidebar'}
          >
            <Sidebar
              isCollapsed={isCollapsed}
              setIsCollapsed={setIsCollapsed}
              routes={filteredRoutes}
            />
          </Grid>
        )}
        <Grid size={'grow'}>
          <Header
            isCollapsed={isCollapsed}
            setIsCollapsed={setIsCollapsed}
            routes={filteredRoutes}
          />
          <Box sx={{ padding: '0 20px' }}>{children}</Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Layout;
